import { formatISO, parseISO } from 'date-fns';
import ProjectUser from './project-user';
import Team from './team';
export default class Project {
    constructor(dto) {
        this.dto = Object.assign({}, dto);
    }
    get id() {
        return this.dto.id;
    }
    set id(id) {
        this.dto.id = id;
    }
    get user() {
        if (!this.dto.user) {
            return null;
        }
        return this.dto.user.replace('/users/', '');
    }
    set user(user) {
        this.dto.user = user;
    }
    get title() {
        return this.dto.title;
    }
    set title(title) {
        this.dto.title = title;
    }
    get description() {
        return this.dto.description;
    }
    set description(description) {
        this.dto.description = description;
    }
    get apiKey() {
        return this.dto.apiKey;
    }
    set apiKey(apiKey) {
        this.dto.apiKey = apiKey;
    }
    get dateCreated() {
        return parseISO(this.dto.dateCreated);
    }
    set dateCreated(dateCreated) {
        this.dto.dateCreated = formatISO(dateCreated);
    }
    get dateUpdated() {
        return parseISO(this.dto.dateUpdated);
    }
    set dateUpdated(dateUpdated) {
        this.dto.dateUpdated = formatISO(dateUpdated);
    }
    get members() {
        return this.dto.members;
    }
    set members(members) {
        this.dto.members = members;
    }
    get projectUsers() {
        const projectUsers = [];
        for (const projectUserDto of this.dto.projectUsers) {
            if (projectUserDto.inherited) {
                continue;
            }
            projectUsers.push(new ProjectUser(projectUserDto));
        }
        return projectUsers;
    }
    set projectUsers(projectUsers) {
        this.dto.projectUsers = [];
        for (const projectUser of projectUsers) {
            this.dto.projectUsers.push(projectUser.dto);
        }
    }
    get teams() {
        const teams = [];
        for (const teamDto of this.dto.teams) {
            teams.push(new Team(teamDto));
        }
        return teams;
    }
    set teams(teams) {
        this.dto.teams = [];
        for (const team of teams) {
            this.dto.teams.push(team.dto);
        }
    }
    get tags() {
        return this.dto.tags;
    }
    set tags(tags) {
        this.dto.tags = tags;
    }
    get params() {
        const data = {
            title: this.title,
            description: this.description,
            apiKey: this.apiKey,
            tags: this.tags,
            projectUsers: [],
            teams: [],
        };
        if (this.user) {
            data.user = `/users/${this.user}`;
        }
        for (const projectMember of this.projectUsers) {
            data.projectUsers.push({
                project: `/projects/${this.dto.id}`,
                user: `/users/${projectMember.userId}`,
                owner: projectMember.owner,
                admin: projectMember.admin,
            });
        }
        for (const team of this.teams) {
            data.teams.push(`/teams/${team.id}`);
        }
        return data;
    }
}
//# sourceMappingURL=project.js.map